import React, { useEffect, useState } from "react";
import { getepubrolemappingdata, sendEpubRoleMappingData } from "../../api/api";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";

const Epubrolemapping = ({ fileId, renderpage }) => {
  const [apiData, setApiData] = useState();
  const [options, setOptions] = useState();
  const { category } = useParams();
  const [stage, setStage] = useState();

  // console.log(fileId);

  useEffect(() => {
    fetchdata(fileId);
  }, [fileId]);

  const fetchdata = async (currentFileId) => {
    try {
      let data = await getepubrolemappingdata(currentFileId, category);
      if (data.data) {
        setOptions(data.data.change);
        setApiData(data.data.tags);
        setStage({
          previous: data.data.previous_process,
          next: data.data.next_process,
        });
      } else {
        // alert(data.error);
        toast.error(data.error.message);
      }
    } catch (e) {
      // alert(e);
      toast.error(e);
    }
  };

  const handleChange = (event, index, type) => {
    let selectedEpubType;
    let selectedRoleMapping;
    if (type === "epubType") {
      selectedEpubType = event.target.value;
    } else if (type === "roleMapping") {
      selectedRoleMapping = event.target.value;
    }

    const correspondingRoleMapping = options.find(
      (opt) => opt[Object.keys(opt)][0] === selectedEpubType
    );

    setApiData((prev) =>
      prev.map((item, i) =>
        i === index
          ? {
              ...item,
              epub_type:
                type === "epubType"
                  ? selectedEpubType === "select an option"
                    ? item.epub_type
                    : selectedEpubType
                  : item.epub_type,
              role_mapping:
                type === "epubType"
                  ? correspondingRoleMapping[
                      Object.keys(correspondingRoleMapping)
                    ][1]
                  : selectedRoleMapping === "select an option"
                  ? item.role_mapping
                  : selectedRoleMapping,
            }
          : item
      )
    );
  };

  const senddata = async (event) => {
    const button = event.currentTarget;
    button.disabled = true; // Disable the button
    document.body.style.cursor = "wait";
    try {
      if (apiData) {
        button.disabled = true;
        document.body.style.cursor = "wait";
        let response = await sendEpubRoleMappingData(fileId, apiData, category);
        if (response.data) {
          document.body.style.cursor = "default";
          handleNext(fileId, stage.next);
        } else {
          // alert(response.error.message);
          toast.error(response.error.message);
          button.disabled = false;
          document.body.style.cursor = "default";
        }
      }
    } catch (e) {
      // console.log(e);
      toast.error(e);
      button.disabled = false;
      document.body.style.cursor = "default";
    }
  };

  const handleNext = (fileId, nextpage) => {
    renderpage(fileId, nextpage);
  };

  // console.log(apiData);
  // console.log(options);

  return (
    <div className="flex flex-col w-full">
      <div className="p-8 flex flex-col gap-8 h-[100%] min-h-[70vh]">
        <div className="flex w-full justify-between text-left items-center">
          <h1 className="text-24 font-semibold">ePub Type / Role Mapping</h1>
          <button
            onClick={() => toast.info("Feature yet to be implemented")}
            className="flex gap-2 px-3 py-3 border-[1.5px] border-highlighttext rounded-[12px]"
          >
            <img
              src={process.env.PUBLIC_URL + "/images/gotoeditor.svg"}
              alt="editor_logo"
            ></img>
            <p className="text-highlighttext text-14 font-semibold">
              Go to Editor
            </p>
          </button>
        </div>
        <div className="overflow-auto max-h-[600px] rounded-[16px] border-[1px] border-commonborder shadow-commonshadow">
          <table className="w-full ">
            <thead className="sticky top-0 z-10 bg-tableheadingbg px-4 py-6 text-left text-white text-16 font-semibold">
              <tr className="">
                <th className="px-4 py-5">HTML Name</th>
                <th className="px-4 py-5">ePub Type</th>
                <th className="px-4 py-5">Role Mapping</th>
              </tr>
            </thead>
            <tbody className="w-full text-left bg-white">
              {apiData?.map((items, i) => (
                <tr
                  key={i}
                  className="border-b-[1px] border-commonborder last:border-none"
                >
                  <td
                    className="px-4 py-5 overflow-hidden"
                    style={{ width: "20%" }}
                  >
                    <p
                      className="px-4 py-3 rounded-[8px] bg-commonfill"
                      title={items.html}
                    >
                      {items.html}
                    </p>
                  </td>
                  <td className="px-4 py-5 relative">
                    <select
                      className="rounded-[8px] bg-commonfill px-4 py-3 w-full appearance-none"
                      style={{ accentColor: "#FF6A00" }}
                      value={items.epub_type}
                      onChange={(e) => handleChange(e, i, "epubType")}
                    >
                      {/* <option value={"select an option"}>
                        Select an Option
                      </option> */}
                      {Array.from(
                        new Set(
                          options?.map((items) => {
                            const key = Object.keys(items)[0];
                            return items[key]?.[0]; // Extract the first value
                          })
                        )
                      ).map((value, index) => (
                        <option key={index} value={value}>
                          {value}
                        </option>
                      ))}
                    </select>
                    <svg
                      class="absolute top-1/2 right-8 transform -translate-y-1/2 w-4 h-4 text-gray-500 pointer-events-none"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M19 9l-7 7-7-7"
                      ></path>
                    </svg>
                  </td>
                  <td className="px-4 py-5 relative">
                    <select
                      className="rounded-[8px] bg-commonfill px-4 py-3 w-full appearance-none"
                      style={{ accentColor: "#FF6A00" }}
                      value={items.role_mapping}
                      onChange={(e) => handleChange(e, i, "roleMapping")}
                    >
                      {/* <option value={"select an option"}>
                        Select an Option
                      </option> */}
                      {Array.from(
                        new Set(
                          options?.map((items) => {
                            const key = Object.keys(items)[0];
                            return items[key][1]; // Extract the second value
                          })
                        )
                      ).map((value, index) => (
                        <option key={index} value={value}>
                          {value}
                        </option>
                      ))}
                    </select>
                    <svg
                      class="absolute top-1/2 right-8 transform -translate-y-1/2 w-4 h-4 text-gray-500 pointer-events-none"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M19 9l-7 7-7-7"
                      ></path>
                    </svg>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="flex ml-auto gap-5">
          <button
            onClick={(event) => {
              handleNext(fileId, stage.previous);
            }}
            className="w-fit mt-20 flex "
          >
            <p className="py-3 px-6 rounded-[12px] text-white bg-highlight text-14 font-bold">
              PREV
            </p>
          </button>
          <button
            onClick={(event) => {
              senddata(event);
            }}
            className="w-fit mt-20 flex"
          >
            <p className="py-3 px-6 rounded-[12px] text-white bg-highlight text-14 font-bold">
              NEXT
            </p>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Epubrolemapping;
